export const convertReferralHistoryEvoResponse = (response) => {
    var _a;
    return {
        items: response.data.map((item) => ({
            points: item.points,
            date: item.created_at,
            event: item.type,
        })),
        total: (_a = response.meta.total) !== null && _a !== void 0 ? _a : 0,
    };
};
//# sourceMappingURL=convertReferralHistoryEvoResponse.js.map